import isNil from 'lodash/isNil';
import { formatInTimeZone } from 'date-fns-tz';

export const getLastUpdated = (timestamp?: number) =>
  timestamp
    ? formatInTimeZone(timestamp, Intl.DateTimeFormat().resolvedOptions().timeZone, 'h:mm a z')
    : '';

export const getSafeLocaleString = (value?: number) =>
  isNil(value) ? 'unknown' : value.toLocaleString();

export const getPercentage = (sent?: number, size?: number) => {
  if (isNil(sent) || isNil(size) || sent === 0 || size === 0) return 0;
  const percentage = Math.round(((sent as number) / (size as number)) * 100); // nearest integer percentage
  return percentage;
};
